<template>
  <div class="dc-passport-evidence">
    <img :src="entry.evidence_url" :alt="title" @error="$emit('preview-error', entry.evidence_url)" />
    <span v-if="entry.bbox" class="dc-passport-bbox" :style="boxStyle" data-testid="passport-bbox" aria-hidden="true" />
  </div>
</template>

<script>
export default {
  name: 'PassportEvidence',
  props: { entry: { type: Object, required: true }, title: { type: String, required: true } },
  computed: {
    boxStyle() {
      const box = this.entry.bbox;
      return box ? { left: `${box.x * 100}%`, top: `${box.y * 100}%`, width: `${box.w * 100}%`, height: `${box.h * 100}%` } : {};
    },
  },
};
</script>

<style scoped>
.dc-passport-evidence { position: relative; width: 100%; overflow: hidden; }
.dc-passport-evidence img { display: block; width: 100%; height: auto; }
.dc-passport-bbox { position: absolute; box-sizing: border-box; border: 3px solid #c62828; outline: 1px solid white; pointer-events: none; }
</style>
